import { Workspace, WorkspaceData } from "@workspace/types";
import { clientFetcher } from "@workspace/api";

export const getWorkspaces = async (): Promise<WorkspaceData[]> => {
  return (await clientFetcher.get("/workspaces")).data.items;
};

export const createWorkspace = async (data: {
  name: string;
}): Promise<Workspace> => {
  return (await clientFetcher.post("/workspaces/new", data)).data;
};

export const renameWorkspace = async (
  id: string,
  name: string,
): Promise<void> => {
  await clientFetcher.patch(`/workspaces/${id}`, { name });
};

export const getOrCreate = async (data: {
  name: string;
}): Promise<WorkspaceData[]> => {
  let workspaces = await getWorkspaces();

  if (workspaces?.length === 0) {
    const newWorkspace = await createWorkspace(data);
    workspaces = [{ workspace: newWorkspace, role: "admin" }];
  }

  return workspaces;
};
